const re = (expression) => {
    return new RegExp(expression)
}

const validators = {
  emailFormat : (email) => {
    return re(/^.+\@.+\..+$/).test(email)
  },

  phoneNumberFormat : (phoneNumber) => {
      return re(/^[0-9]{9}$/).test(phoneNumber)
  },

  hasValue : (text) => {
      var value = text

      if (value === null || value === undefined)
          return false

      if (typeof value !== 'string')
          value = value.toString()

      value = value.trim()

      return re(/^.+/).test(value)
  }

}

export default validators